import React, { Component } from 'react'

import { getOptionableProducts } from '../../services/api'
import { constructError } from '../../services/errors.js'

import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import Grid from '@material-ui/core/Grid'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormHelperText from '@material-ui/core/FormHelperText'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import RemoveIcon from '@material-ui/icons/Remove'
import Button from '@material-ui/core/Button'

import './ProductOptions.css'

export default class ProductOptions extends Component {
  state = {
    newid: -1
  }

  async componentDidMount() {
    const { merchantCode, productId } = this.props
    const options = await getOptionableProducts(merchantCode)
    this.setState({
      options: options.filter(option => option.id !== productId)
    })
  }

  selectChange = (id, name) => e => {
    this.props.changeOption(id, name, e.target.value)
  }
  checkboxChange = (id, name) => e => {
    this.props.changeOption(id, name, e.target.checked)
  }
  addOption = () => {
    this.props.addOption(this.state.newid)
    this.setState(state => ({ newid: state.newid - 1 }))
  }
  renderOption(productOption, index, error) {
    const { options } = this.state
    const { productOptions, deleteOption } = this.props

    return (
      <Grid
        container
        justify="center"
        alignItems="center"
        item
        xs={12}
        spacing={16}
        key={productOption.id}
      >
        <Grid item sm={1}>
          <FormControl margin="normal">
            <IconButton onClick={deleteOption(productOption.id)}>
              <RemoveIcon />
            </IconButton>
          </FormControl>
        </Grid>
        <Grid item sm={5} xs={4}>
          <FormControl fullWidth margin="normal" error={error !== undefined}>
            <InputLabel htmlFor="option">Composant {index}</InputLabel>
            <Select
              value={productOption.optionId}
              onChange={this.selectChange(productOption.id, 'optionId')}
              inputProps={{ id: 'option' }}
            >
              <MenuItem value="">
                <em>Sélectionnez un produit...</em>
              </MenuItem>
              {options.map(option => (
                <MenuItem
                  value={option.id}
                  key={option.id}
                  disabled={productOptions.some(
                    opt => opt.optionId === option.id
                  )}
                >
                  {option.value.technicalLabel}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>
              {error && constructError(error['optionId'])}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item sm={3}>
          <FormControl margin="normal">
            <FormControlLabel
              control={
                <Checkbox
                  checked={productOption.mandatory}
                  onChange={this.checkboxChange(productOption.id, 'mandatory')}
                  value="mandatory"
                  color="secondary"
                />
              }
              label="Obligatoire"
            />
          </FormControl>
        </Grid>
        <Grid item sm={3}>
          {!productOption.mandatory && (
            <FormControl margin="normal">
              <FormControlLabel
                margin="normal"
                control={
                  <Checkbox
                    checked={productOption.precheck}
                    onChange={this.checkboxChange(productOption.id, 'precheck')}
                    value="preCheck"
                    color="secondary"
                  />
                }
                label="Pré-coché"
              />
            </FormControl>
          )}
        </Grid>
      </Grid>
    )
  }
  render() {
    const { options } = this.state
    const { productOptions, errors } = this.props

    return options !== undefined ? (
      <Grid container spacing={16} justify="center">
        {productOptions &&
          productOptions.map((productOption, index) =>
            this.renderOption(
              productOption,
              index + 1,
              errors && errors.elements[index]
            )
          )}
        <Button
          className="sp-productoptions--actions"
          variant="contained"
          color="default"
          onClick={this.addOption}
        >
          Ajouter un composant
        </Button>
      </Grid>
    ) : (
      <div>Pas d'options</div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/products/ProductOptions.js